import { DiscountType } from "@/lib/gql/__generated__/graphql";

import type { FormOptionType } from "@/components/ui/form/_types/type";

export const DiscountTypeOptions = [
	{
		id: DiscountType.Ratio,
		label: "一定割合",
		value: DiscountType.Ratio,
	},
	{
		id: DiscountType.Static,
		label: "固定金額",
		value: DiscountType.Static,
	},
] satisfies Array<FormOptionType>;
